//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'RouteError',
  methods: {
    reloadRoute() {
      this.$router.reload();
    },
  },
};
